const React = require('react');
const map = require('mn-utils/map');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const {openPopupInfo} = require('../../../../../emitters/popup');
const {updateWdgets} = require('../../../../../emitters/widgets');
const {COINS} = require('../../../../../constants');
const withState = require('../../../../../utils/withState');
const Field = require('../../../../dumb/Field/E');
const Select = require('../../../../dumb/Select/H');
const TextField = require('../../../../dumb/TextField/A');
const Button = require('../../../../dumb/Button/Accept');

module.exports = withState((setState, self, onMount) => {
  self.state = {
    clicked: false,
    network: '',
    address: '',
    coin: '',
    cryptoCoins: map(COINS, (el) => ({...el, disabled: false})),
  };

  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeCurrency = handleProvider('coin');
  const handleChangeAddress = changeProvider('address');

  return (state, props) => {
    const {clicked} = state;
    const {appId, request} = props;

    const disabled = !state.coin || !state.address;

    const handleSave = () => {
      if (!request || !appId) return;

      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }

      setState({
        loading: true,
      });

      request({
        app_id: appId,
        cc_code: state.coin,
        address: state.address,
      }).finally((error) => {
        error || openPopupInfo(props.resultText);
        updateWdgets();
      });
    };

    return (
      <div>
        <div className="cfx mh-28 (w1/2|ph28|w@m|lt)>1">
          <div className="mt26">
            <Field
              label="Cryptocurrency *"
            >
              <Select
                className="f12 lh17 fw7"
                propName="id"
                propValue="id"
                value={state.coin}
                items={state.cryptoCoins}
                onChange={handleChangeCurrency}
                error={clicked}
                helperText="Obligatory field"
              />
            </Field>
          </div>
          <TextField
            className="mt26"
            label="Crypto Address*"
            value={state.address}
            onChange={handleChangeAddress}
            error={clicked}
          />
        </div>
        <div className="mt30 layoutRow fhaS fvaC">
          <Button
            disabled={clicked && disabled}
            onClick={handleSave}
          >Create Wallet</Button>
        </div>
      </div>
    );
  };
});
